import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Methodology from "@/pages/Methodology";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Gracias from "@/pages/Gracias";
import Legal from "@/pages/Legal";

const SEO = {
  "/": {
    title: "Consultoría para empresas y pymes | Medite Group",
    desc: "Consultoría estratégica, financiera y digital para pymes. Hacemos crecer empresas con estrategia, tecnología, automatización e inteligencia artificial.",
  },
  "/services": {
    title: "Servicios de consultoría estratégica, financiera y digital | Medite Group",
    desc: "Estrategia empresarial, soluciones financieras, transformación digital y automatización con inteligencia artificial para pymes.",
  },
  "/methodology": {
    title: "Nuestra metodología | Medite Group",
    desc: "Analizamos, diagnosticamos, diseñamos, implementamos y mejoramos de forma continua para lograr resultados reales en tu empresa.",
  },
  "/about": {
    title: "Sobre nosotros | Medite Group",
    desc: "Medite Group, tu socio estratégico a largo plazo. Consultoría para pymes basada en la confianza, el compromiso y los resultados.",
  },
  "/contact": {
    title: "Contacto y diagnóstico inicial | Medite Group",
    desc: "Solicita un diagnóstico inicial sin compromiso. Consultoría para empresas en Barcelona: estrategia, finanzas, digitalización y automatización.",
  },
  "/gracias": { title: "Gracias por contactar | Medite Group", desc: "Hemos recibido tu solicitud. Te responderemos en un día laborable." },
  "/privacidad": { title: "Política de Privacidad | Medite Group", desc: "Política de privacidad de Medite Group." },
  "/aviso-legal": { title: "Aviso Legal | Medite Group", desc: "Aviso legal de Medite Group." },
  "/cookies": { title: "Política de Cookies | Medite Group", desc: "Política de cookies de Medite Group." },
};

function Shell() {
  useLenis();
  const location = useLocation();

  useEffect(() => {
    const meta = SEO[location.pathname] || SEO["/"];
    document.title = meta.title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", meta.desc);
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/methodology" element={<Methodology />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gracias" element={<Gracias />} />
            <Route path="/privacidad" element={<Legal variant="privacidad" />} />
            <Route path="/aviso-legal" element={<Legal variant="aviso-legal" />} />
            <Route path="/cookies" element={<Legal variant="cookies" />} />
          </Routes>
        </AnimatePresence>
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}

export default App;
